<div class="loading-spinner-container" *ngIf="isLoading$ | async">
    <div class="loading-spinner">

    </div>
</div>